(function (window, jQuery) {
    "use strict"

    jQuery(function ($) {
        $(document).ready(function () {
            const $animate_cards = $('.home-animate__card')
            let animate_card_count = 0

            setInterval(function () {
                $animate_cards.eq(animate_card_count).addClass('animate')
                animate_card_count++
                if (animate_card_count == $animate_cards.length + 1) {
                    animate_card_count = 0
                    $animate_cards.removeClass('animate')
                }
            }, 3000)
        })
    })


})(window, window.jQuery)